import Backdrop from "./Backdrop";
import Input from "./Input";

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  return Object.assign(Backdrop(theme), Input(theme));
}
